import { doc, updateDoc } from 'firebase/firestore'

export const SEGNA_FEEDBACK_LETTO = async (id) => {
    await updateDoc(doc(db, 'feedBack', id), { finito: true })
    return
}
